import { VStack } from '@chakra-ui/react';
import BillingInvoiceSettings from './accordionSections/BillingInvoiceSettings';
import CompanyBillingInvoiceFormat from './accordionSections/BillingInvoiceFormat';
import BillingInvoiceExport from './accordionSections/BillingInvoiceExport';
import { useCompanyForm } from '../hooks/useCompanyForm';
import { getBillingSettings } from '../constants';

const CompanyBillingInvoice = ({
    darkMode,
    errors,
    touched,
    organisationMode,
    isCompany,
    defaultPlansData,
}) => {
    const { formData } = useCompanyForm();

    const billingState = getBillingSettings(formData, organisationMode);

    return (
        <VStack spacing={4} align="stretch">
            <BillingInvoiceSettings
                darkMode={darkMode}
                errors={errors}
                touched={touched}
                isCompany={isCompany}
                defaultPlansData={defaultPlansData}
            />
            <BillingInvoiceExport
                darkMode={darkMode}
                errors={errors}
                touched={touched}
                organisationMode={organisationMode}
            />
            <CompanyBillingInvoiceFormat
                darkMode={darkMode}
                errors={errors}
                touched={touched}
                billingState={billingState}
                organisationMode={organisationMode}
            />
        </VStack>
    );
};

export default CompanyBillingInvoice;
